const allConfiguration = (state = {}, action) => {
  if (action.type === "setConfiguration") {
    return action.payload;
  } else {
    return state;
  }
};

export default allConfiguration;
